import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Subscription, interval} from 'rxjs';

@Component({
  selector: 'app-inactivity-modal',
  templateUrl: './inactivity-modal.component.html',
  standalone: false
})
export class InactivityModalComponent implements OnInit, OnDestroy {
  @Input() countdown: number = 30;

  private timerSubscription?: Subscription;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.timerSubscription = interval(1000).subscribe(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.activeModal.close('logout');
      }
    });
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  stay(): void {
    this.activeModal.close('stay');
  }

  logout(): void {
    this.activeModal.close('logout');
  }
}
